"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import './utils/hats'; //TODO: 暂时下掉hats高速通道，待hats支持cookie http-only后开启
const vue_1 = require("vue");
require("@/registerServiceWorker");
const router_1 = __importDefault(require("@/router"));
const store_1 = __importDefault(require("@/store"));
const i18n_1 = require("@/locales/i18n");
const elementui_1 = require("@/plugins/elementui");
const icons_1 = require("@/icons");
const directive_precision_1 = require("@/plugins/directive-precision");
const directive_clickoutside_1 = require("@/plugins/directive-clickoutside");
const directive_image_1 = __importDefault(require("@/plugins/directive-image"));
const gtm_1 = require("@/plugins/gtm");
// @ts-ignore
const App_1 = __importDefault(require("./App"));
const app = (0, vue_1.createApp)(App_1.default);
app
    .use(store_1.default)
    .use(router_1.default)
    .use(i18n_1.i18n)
    .use(elementui_1.install)
    .use(directive_precision_1.install)
    .use(directive_clickoutside_1.install)
    .use(directive_image_1.default)
    .use(icons_1.install);
if (!window.sfe.prerender) {
    window.addEventListener('load', () => {
        app.use(gtm_1.gtm);
    }, false);
}
app.mount('#root');
try {
    localStorage.removeItem('SPOT_ab_sw');
    localStorage.removeItem('SPOT_pc_version');
    localStorage.removeItem('SPOT_abtest_hats');
}
catch (e) { } // eslint-disable-line
